import kebabCase from 'lodash/fp/kebabCase';
import lowerCase from 'lodash/fp/lowerCase';
import pipe from 'lodash/fp/pipe';

const toTestId = pipe(lowerCase, kebabCase);

export default toTestId;
